module.exports = __webpack_public_path__ + "static/7-2-0eee76604b060743aa49f3d474581f3a.png";